import { openDB } from 'idb';

const baseName = 'yt-channel-scanner';
const dbVersion = 2;

function getActiveUserId() {
  return localStorage.getItem('ytcs:userId') || 'guest';
}

function getDbName() {
  return `${baseName}-${getActiveUserId()}`;
}

export function setActiveUserId(userId) {
  localStorage.setItem('ytcs:userId', userId || 'guest');
}

export async function initDB() {
  const dbName = getDbName();
  return await openDB(dbName, dbVersion, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('channels')) {
        const channels = db.createObjectStore('channels', { keyPath: 'id' });
        channels.createIndex('byTitle', 'title', { unique: false });
        channels.createIndex('byLastVideoDate', 'lastVideoDate', { unique: false });
      }
      if (!db.objectStoreNames.contains('videos')) {
        const videos = db.createObjectStore('videos', { keyPath: 'id' });
        videos.createIndex('byChannel', 'channelId', { unique: false });
        videos.createIndex('byPublishedAt', 'publishedAt', { unique: false });
        videos.createIndex('byTitle', 'title', { unique: false });
      }
      if (!db.objectStoreNames.contains('subscriptions')) {
        db.createObjectStore('subscriptions', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('scans')) {
        db.createObjectStore('scans', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('settings')) {
        db.createObjectStore('settings', { keyPath: 'key' });
      }
    }
  });
}

export async function getChannel(db, channelId) {
  return await db.get('channels', channelId);
}

export async function addChannel(db, channel) {
  return await db.put('channels', channel);
}

export async function addVideo(db, video) {
  return await db.put('videos', video);
}

export async function getVideosByChannel(db, channelId) {
  return await db.getAllFromIndex('videos', 'byChannel', channelId);
}

export async function setSetting(db, key, value) {
  return await db.put('settings', { key, value });
}

export async function getSetting(db, key) {
  return await db.get('settings', key);
}

export async function countStore(db, storeName) {
  return await db.count(storeName);
}

export async function getAllFromStore(db, storeName) {
  return await db.getAll(storeName);
}

export async function clearStore(db, storeName) {
  return await db.clear(storeName);
}

export async function bulkPut(db, storeName, items) {
  const tx = db.transaction(storeName, 'readwrite');
  const store = tx.objectStore(storeName);
  for (const item of items) {
    await store.put(item);
  }
  await tx.done;
}
